/**
 * @fileoverview Shared scalar constants used across API and CMS UI code.
 */

const isProd = process.env.NODE_ENV === 'production';

export const SOLR_DELAY = isProd ? 500 : 1000;

export const SUPPORT_USER_NAME = 'signstix_support';

export const PUBLIC_LIST_DEFAULT_LIMIT = 25;

export const PUBLIC_LIST_MAX_LIMIT = 100;
